import {
  isOfflineAndroid,
  createRequestId,
  ensureCallbackRegistry
} from './androidOfflineCart';


/**
 * Create an offline customer.
 *
 * Android:
 *
 * saveOfflineCustomer(
 *   requestId,
 *   firstName,
 *   lastName,
 *   email,
 *   contactNumber,
 *   subscribed
 * )
 */
const saveOfflineCustomer = ({
  firstName,
  lastName,
  email,
  contactNumber,
  subscribed = false
}) => {

  return new Promise((resolve, reject) => {

    if (!isOfflineAndroid()) {
      reject(
        new Error(
          'Android POS offline bridge unavailable'
        )
      );
      return;
    }

    if (
      typeof window.AndroidPOS.saveOfflineCustomer !==
      'function'
    ) {
      reject(
        new Error(
          'AndroidPOS.saveOfflineCustomer is not available'
        )
      );
      return;
    }

    const requestId =
      createRequestId('save_offline_customer');

    ensureCallbackRegistry();

    window.__orderArtOfflineCallbacks[requestId] = {
      resolve,
      reject
    };

    try {

      window.AndroidPOS.saveOfflineCustomer(
        requestId,

        String(firstName ?? ''),

        String(lastName ?? ''),

        String(email ?? ''),

        String(contactNumber ?? ''),

        Boolean(subscribed)
      );

    } catch (error) {

      delete window.__orderArtOfflineCallbacks[
        requestId
      ];

      reject(error);

      return;
    }

    setTimeout(() => {

      if (
        window.__orderArtOfflineCallbacks[requestId]
      ) {

        delete window.__orderArtOfflineCallbacks[
          requestId
        ];

        reject(
          new Error(
            `Offline save customer timeout: ${requestId}`
          )
        );
      }

    }, 10000);
  });
};


/**
 * Search offline customers.
 *
 * Android:
 *
 * searchOfflineCustomers(
 *   requestId,
 *   query
 * )
 */
const searchOfflineCustomers = (
  query
) => {

  return new Promise((resolve, reject) => {

    if (!isOfflineAndroid()) {
      reject(
        new Error(
          'Android POS offline bridge unavailable'
        )
      );
      return;
    }

    if (
      typeof window.AndroidPOS.searchOfflineCustomers !==
      'function'
    ) {
      reject(
        new Error(
          'AndroidPOS.searchOfflineCustomers is not available'
        )
      );
      return;
    }

    const requestId =
      createRequestId('search_offline_customers');

    ensureCallbackRegistry();

    window.__orderArtOfflineCallbacks[requestId] = {
      resolve,
      reject
    };

    try {

      window.AndroidPOS.searchOfflineCustomers(
        requestId,
        String(query ?? '')
      );

    } catch (error) {

      delete window.__orderArtOfflineCallbacks[
        requestId
      ];

      reject(error);

      return;
    }

    setTimeout(() => {

      if (
        window.__orderArtOfflineCallbacks[requestId]
      ) {

        delete window.__orderArtOfflineCallbacks[
          requestId
        ];

        reject(
          new Error(
            `Offline customer search timeout: ${requestId}`
          )
        );
      }

    }, 10000);
  });
};


/**
 * Attach a customer to an offline order.
 *
 * Android:
 *
 * updateOfflineOrderCustomer(
 *   requestId,
 *   localOrderId,
 *   localCustomerId
 * )
 */
const updateOfflineOrderCustomer = ({
  orderId,
  localCustomerId
}) => {

  return new Promise((resolve, reject) => {

    if (!isOfflineAndroid()) {
      reject(
        new Error(
          'Android POS offline bridge unavailable'
        )
      );
      return;
    }

    if (
      typeof window.AndroidPOS.updateOfflineOrderCustomer !==
      'function'
    ) {
      reject(
        new Error(
          'AndroidPOS.updateOfflineOrderCustomer is not available'
        )
      );
      return;
    }

    if (!orderId) {
      reject(
        new Error(
          'orderId is required'
        )
      );
      return;
    }

    if (!localCustomerId) {
      reject(
        new Error(
          'localCustomerId is required'
        )
      );
      return;
    }

    const requestId =
      createRequestId('update_offline_order_customer');

    ensureCallbackRegistry();

    window.__orderArtOfflineCallbacks[requestId] = {
      resolve,
      reject
    };

    try {

      window.AndroidPOS.updateOfflineOrderCustomer(
        requestId,
        String(orderId),
        String(localCustomerId)
      );

    } catch (error) {

      delete window.__orderArtOfflineCallbacks[
        requestId
      ];

      reject(error);

      return;
    }

    setTimeout(() => {

      if (
        window.__orderArtOfflineCallbacks[requestId]
      ) {

        delete window.__orderArtOfflineCallbacks[
          requestId
        ];

        reject(
          new Error(
            `Offline update customer timeout: ${requestId}`
          )
        );
      }

    }, 10000);
  });
};

const getOfflineCustomer = (localCustomerId) => {

  return new Promise((resolve, reject) => {

    if (!isOfflineAndroid()) {
      reject(
        new Error(
          'Android POS offline bridge unavailable'
        )
      );
      return;
    }

    if (
      typeof window.AndroidPOS.getOfflineCustomer !==
      'function'
    ) {
      reject(
        new Error(
          'AndroidPOS.getOfflineCustomer is not available'
        )
      );
      return;
    }

    const requestId =
      createRequestId('get_offline_customers');

    ensureCallbackRegistry();

    window.__orderArtOfflineCallbacks[requestId] = {
      resolve,
      reject
    };

    try {

      window.AndroidPOS.getOfflineCustomer(
        requestId,
        String(localCustomerId)
      );

    } catch (error) {

      delete window.__orderArtOfflineCallbacks[
        requestId
      ];

      reject(error);

      return;
    }

    setTimeout(() => {

      if (
        window.__orderArtOfflineCallbacks[requestId]
      ) {

        delete window.__orderArtOfflineCallbacks[
          requestId
        ];

        reject(
          new Error(
            `Offline get customer timeout: ${requestId}`
          )
        );
      }

    }, 10000);
  });
};


export {
  saveOfflineCustomer,
  searchOfflineCustomers,
  updateOfflineOrderCustomer,
  getOfflineCustomer
};
